import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { DocumentDistributionRuleView } from "../shared/document-distribution-rule.view";
import { DxDataGridComponent } from "devextreme-angular";

@Component({
    selector: 'op-document-distribution-rule-table',
    templateUrl: './rule-table.component.html'
})
export class DocumentDistributionRuleTableComponent implements AfterViewInit {
    public selectedItem: DocumentDistributionRuleView;
    public itemSelected: DocumentDistributionRuleView;
    public rows = 0;
    public header: string[] = [];
    public exportData: any;
    public pdfDefaultStyle = {
        fontSize: 10
    };

    @Input() rules: DocumentDistributionRuleView[] = new Array(); 
    @Output() onEdit = new EventEmitter();
    @Output() onRowSelected = new EventEmitter();

    @ViewChild('dataGridRule', { static: false }) dataGrid: DxDataGridComponent;

    constructor(private changeDetectionRef: ChangeDetectorRef) {
        
    }

    ngAfterViewInit(): void {
        this.getDataGridHeader();
    }

    selectedRow(e) {
        this.selectedItem = e.data;
        this.onRowSelected.emit();
    }

    editRuleDetail() {
        this.onEdit.emit();
    }

    private getDataGridHeader() {
        this.header = this.dataGrid.instance.getVisibleColumns().map(item => item.caption);
    }

    public getNumberOfRows(e) {
        this.rows = e.component.totalCount();
        this.getExportData()?.done((filteredData) => {
            this.exportData = this.mapExportData(filteredData);
        });        

        this.changeDetectionRef.detectChanges();
    }

    private getExportData() {
        let filterExpr = this.dataGrid.instance.getCombinedFilter();
        let gridDataSource = this.dataGrid.instance.getDataSource();
        return gridDataSource?.store().load({
            filter: filterExpr,
        });
    }

    public mapExportData(filteredData) {
        return filteredData.map(dat => (
            {
                No: dat.no,
                Type: dat.addressTypeName,
                Primary: dat.primaryAddress,
                AddressLine1: dat.addressLine1,
                Province: dat.province,
                CountryName: dat.countryName,
            }
        ));
    }
}